import type { LangType, PublishedDateType, schema } from 'database';
import { atom } from 'jotai';
import { ACME_HOME_LAYOUT } from 'mdx-transformer/parse-layout/acme';

export const designAtom = atom<{ enabled: boolean; iframe?: Document }>({
  enabled: false,
});

// All
export const logoAtom = atom<string>(ACME_HOME_LAYOUT.logo);
export const faviconAtom = atom<string>(ACME_HOME_LAYOUT.favicon);
export const headerLinksAtom = atom<schema.BlogLink[]>(
  ACME_HOME_LAYOUT.headerLinks,
);
export const headerActionsAtom = atom<schema.HeaderActions>({});
export const footerLinksAtom = atom<schema.BlogLink[]>(
  ACME_HOME_LAYOUT.footerLinks,
);
export const copyrightAtom = atom<string>(ACME_HOME_LAYOUT.copyright);
export const showQuotionBadgeAtom = atom(true);
export const quotionBadgeUrlAtom = atom('');

export const themeAtom = atom<schema.ThemeType>('Modern');
export const langAtom = atom<LangType>('en');
export const fontAtom = atom('Inter');
export const fontSizeAtom = atom(16);
export const brandColorAtom = atom('brand');
export const allCssVariablesAtom = atom<schema.AllCssVariables | null>(null);
export const allCssAtom = atom('');
export const allJsAtom = atom('');

// Profile
export const defaultAuthorAtom = atom<schema.DefaultAuthor>({
  id: '',
  name: '',
  title: 'Creator',
  avatar: '',
});

// Home
export const heroAtom = atom('');
export const homeCssVariablesAtom = atom<schema.HomeCssVariables | null>(null);
export const showSortMenuAtom = atom(true);
export const showTagTabsAtom = atom(true);
export const defaultSortByAtom = atom<schema.SortByOption>('mostRecent');
export const metaTitleAtom = atom('');
export const metaDescriptionAtom = atom('');
export const enableHomeNewsletterAtom = atom(false);
export const homeNewsletterTitleAtom = atom('');
export const homeNewsletterDescriptionAtom = atom('');
export const homeCssAtom = atom('');
export const homeJsAtom = atom('');

// Post
export const showBreadcrumbAtom = atom(true);
export const showReadTimeAtom = atom(true);
export const showExcerptAtom = atom(false);
export const extractCoverImageAtom = atom(false);
export const showPublishDateAtom = atom(true);
export const publishedDateTypeAtom = atom<PublishedDateType>('updatedDate');
export const showCodeLineNumberAtom = atom(true);
export const aiGeneratedImageCaptionAtom = atom(false);
export const enableKatexAtom = atom(false);
export const codeThemeAtom = atom('dracula');
export const showTocAtom = atom(true);
export const showCommentAtom = atom(false);
export const showLikeAtom = atom(false);
export const showMoreFromAtom = atom(true);
export const enablePostNewsletterAtom = atom(false);
export const postNewsletterTitleAtom = atom('');
export const postNewsletterDescriptionAtom = atom('');
export const postCssAtom = atom('');
export const postJsAtom = atom('');
export const shareListAtom = atom<schema.ShareOption[]>([
  'copy',
  'x',
  'facebook',
  'linkedin',
]);

export const publishAtAtom = atom<Date | null>(null);
